import { action, makeObservable } from 'mobx';
import { runtime, Runtime } from '../Runtime';
import { PackageShelf } from '../../../packages/PackageShelf';
import { AsyncPackage } from '../package/AsyncPackage';
import { getPackagesNamesForSerialized } from '../../../packages/package_resolve';

export class RuntimePackages {
  readonly parent: Runtime;

  constructor(parent) {
    makeObservable(this);
    this.parent = parent;
  }

  get runtime(): Runtime {
    return this.parent;
  }

  get packageShelf(): PackageShelf {
    return this.runtime.runtimeInjected && this.runtime.runtimeInjected.packageShelf;
  }

  @action.bound
  makeAllPackagesAvailable() {
    this.packageShelf.packageNames.forEach((packageName) => {
      (this.packageShelf[packageName] as AsyncPackage).fetchPackage();
    });
  }

  getMissingPackagesNamesForSerialized(ser) {
    return getPackagesNamesForSerialized(ser).filter((n) => !runtime.runtimePackages.packageShelf[n].isAvailable);
  }

  async fetchMissingPackagesForSerialized(ser) {
    const missingPackageNames = this.getMissingPackagesNamesForSerialized(ser);
    await Promise.all(missingPackageNames.map((n) => runtime.runtimePackages.packageShelf[n].fetchPackage()));
    return;
  }

  canSerializedBeInstantiatedSynchronously(ser): boolean {
    const missingPackageNames = this.getMissingPackagesNamesForSerialized(ser);
    const trigger = missingPackageNames.map((n) => runtime.runtimePackages.packageShelf[n].streamedPackage);
    return missingPackageNames.length === 0;
  }
}
